<template>
  <img
    v-if="brokerLogo"
    class="mx-auto my-6 h-11 w-auto"
    :src="brokerLogo"
    alt="broker logo"
  />
  <holding-tank-layout-wide>
    <h1 class="header-text mb-6 leading-none text-dark-blue md:mb-8">
      Connect your ELD to Highway
    </h1>
    <p class="mt-4">
      Please call 906-HIGHWAY or email us at
      <a
        class="text-yellow-600 underline"
        href="mailto:service@highway.com"
        >service@highway.com</a
      >
      to continue connecting your ELD to Highway.
    </p>
    <div class="mt-6 w-full">
      <button-main
        :is-loading="isLoading"
        variant="primary"
        @click="closeEld"
      >
        Return
      </button-main>
    </div>
    <!-- <p class="h4-style mb-6 -mt-3">Authenticate your ELD</p>
    <p class="mt-4 mb-1 text-dark-blue text-base">Step 1</p>
    <div class="rounded-md border border-light-gray p-4">
      <span class="text-sm">Sign in to your ELD provider account</span>
    </div>
    <p class="mt-4 mb-1 text-dark-blue text-base">Step 2</p>
    <div
      class="flex flex-col justify-between items-center rounded-md border border-light-gray py-3 px-5"
    >
      <div class="w-full mb-2">
        <span class="text-start text-dark-gray text-sm mt-3"
          >Invite the below email address to join your account</span
        >
      </div>
      <div class="flex justify-start items-center w-full">
        <div class="flex justify-start items-center w-full">
          <input
            v-on:focus="$event.target.select()"
            ref="clone"
            readonly
            :value="highway_username"
            @click="copyHighwayUsername"
            :style="{ width: getWidth }"
            class="no-border italic flex-1 text-sm bg-transparent border-0 focus:border-0 border-transparent text-gray-500 focus:border-transparent active:border-transparent"
          />
          <button
            @click="copyHighwayUsername"
            type="button"
            class="inline-flex items-center rounded-full border border-transparent bg-light-gray px-3 py-1.5 text-xs font-medium text-body-color hover:text-dark-gray shadow-sm hover:bg-placeholder-gray focus:outline-none gap-x-1"
          >
            <svg
              v-if="copy_button_text == 'Copy'"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-3 h-3"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5A3.375 3.375 0 006.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0015 2.25h-1.5a2.251 2.251 0 00-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 00-9-9z"
              />
            </svg>
            <span>{{ copy_button_text }}</span>
          </button>
        </div>
      </div>
    </div>
    <p class="mt-4 mb-1 text-dark-blue text-base">Step 3</p>
    <div class="rounded-md border border-light-gray p-4">
      <p class="text-sm mt-3 mb-4">
        Submit and hang tight while we verify your account
      </p>
      <radio-button
        :item="checkboxText"
        :active="isChecked == true"
        :handleSelect="handleCheckbox"
        name="checkbox-confirm"
      ></radio-button>

      <div class="mt-6 w-full">
        <button-main
          @click="handleSubmit"
          :disabled="!isChecked"
          :isLoading="isLoading"
          variant="primary"
          >Submit
        </button-main>
      </div>
      <div class="mt-3 w-full">
        <button-main @click="handleBack" variant="secondary">Back</button-main>
      </div>
    </div> -->
  </holding-tank-layout-wide>
</template>

<script>
import { toastResponse } from '@/common/handleServerResponse';
import HoldingTankLayoutWide from '@/components/layouts/HoldingTankLayoutWide.vue';
// import RadioButton from "@/components/RadioButton.vue";
import ButtonMain from '@/components/Button.vue';
import stepInformation from '@/common/stepInformation';

export default {
  name: 'ELDNotListed',
  components: {
    HoldingTankLayoutWide,
    ButtonMain,
    // RadioButton,
  },
  data() {
    return {
      isChecked: false,
      isLoading: false,
      copy_button_text: 'Copy',
      verifier_visible: false,
    };
  },
  computed: {
    highway_username() {
      return `eld${this.latest_carrier_eld_provider?.carrier_id}@highway.com`;
    },
    checkboxText() {
      return `I have added ${this.highway_username} to my ELD account`;
    },
    getWidth() {
      return (this.highway_username?.length + 3) * 8 + 'px';
    },
    packetId() {
      return this.$store.state.onboardingPacket?.id;
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
    brokerLogo() {
      return this.$store.state.company?.company?.logo?.url || null;
    },
    requestedCarrierId() {
      return this.$store.state.users?.currentUser?.requested_carrier_id;
    },
  },
  mounted() {
    this.items = stepInformation.verify_physical_assets;
    if (!this.packetId) {
      this.getOnboardingPacket();
    }
    this.$store.dispatch('onboardingPacket/getConnectSubscriptions');
    if (this.latest_carrier_eld_provider?.has_setup_manual_connection == true) {
      this.isChecked = true;
    }
  },
  methods: {
    async closeEld() {
      this.$router.push({
        name: 'Carrier Onboarding Packet Status',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    copyHighwayUsername() {
      this.$refs.clone.focus();
      document.execCommand('copy');
      var activeEl = document.activeElement;
      if (activeEl) {
        var tagName = activeEl.nodeName.toLowerCase();
        if (
          tagName == 'textarea' ||
          (tagName == 'input' && activeEl.type == 'text')
        ) {
          // Collapse the selection to the end
          activeEl.selectionStart = activeEl.selectionEnd;
        }
      }
      this.$refs.clone.blur();
      this.copy_button_text = 'Copied!';
      setTimeout(() => {
        this.copy_button_text = 'Copy';
      }, 2000);
    },
    handleCheckbox() {
      this.isChecked = !this.isChecked;
    },
    async getOnboardingPacket() {
      await this.$store.dispatch('onboardingPacket/getOnboardingPacketById', {
        id: this.$route.params.id,
      });
      await this.$store.dispatch('carriers/getRulesSyntax');
      await this.$store.dispatch(
        'company/getCompanyByClientId',
        localStorage.getItem('client_id')
      );
    },
    handleBack() {
      this.$router.push({
        name: 'Carrier Onboarding Packet Status',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    async handleSubmit() {
      console.log('latest provider', this.latest_carrier_eld_provider);
      this.isLoading = true;
      let res = await this.$store.dispatch(
        'onboardingPacket/updateCarrierEldProvider',
        {
          id: this.latest_carrier_eld_provider?.id,
          body: {
            carrier_eld_provider: {
              has_setup_manual_connection: true,
            },
          },
        }
      );
      toastResponse(
        this,
        res,
        'You will be immediately notified when your pending ELD connection is completed.'
      );

      this.$router.push({
        name: 'Carrier Onboarding Packet Status',
        params: {
          id: this.$route.params.id,
        },
      });
      this.isLoading = false;
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
}

.h4-style {
  font-size: 18px;
  line-height: 27px;
}
</style>
